import { Enum } from "./enum";
export var Intent = Enum({
  NONE: 'none',
  PRIMARY: 'primary',
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger'
});
export function intentClass(intent) {
  if (intent == null || intent === Intent.NONE) {
    return '-default';
  }
  return "-".concat(intent.toLowerCase());
}